import { useSelector } from 'react-redux';
import { HISTORY_SCOPE } from '@src/constants/history';

const useCanUndo = (scope = HISTORY_SCOPE.DUBBING) => {
  const canUndo = useSelector(
    (state) => (state.history?.[scope]?.past?.length ?? 0) > 0,
  );
  return canUndo;
};

export default useCanUndo;
